// axiosInstance.js
import axios from 'axios';
const base_url = "https://r902a4mgz7.execute-api.us-east-2.amazonaws.com/dev";

const instance = axios.create({
  baseURL: base_url,
  retry: false, // Disable retry
});

export default instance;